/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchPostsSkeleton.defs'
export { main as default } from './searchPostsSkeleton.defs'
